import {
  DEFAULT_FLEXIBLE_PROPERTIES_VIEW_MODE,
  FLEXIBLE_PROPERTIES_VIEW_MODE,
  type FlexiblePropertiesViewMode,
} from '../constants/FlexiblePropertiesConstants';
import QueryConstants from '../constants/QueryConstants';
import { ROUTES } from '../constants/urls';
import { replaceRouterQueryParams } from './routerQueryUtils';

import type { NextRouter } from 'next/router';

export type FlexiblePropertiesFilterState = {
  searchText: string;
  includeArchived: boolean;
};

export const defaultFlexiblePropertiesFilters: FlexiblePropertiesFilterState = {
  searchText: '',
  includeArchived: false,
};

const isValidViewMode = (value: string): value is FlexiblePropertiesViewMode =>
  Object.values(FLEXIBLE_PROPERTIES_VIEW_MODE).includes(value as FlexiblePropertiesViewMode);

export const initializeFlexiblePropertiesFiltersFromRouter = (
  query: NextRouter['query'],
  defaults: FlexiblePropertiesFilterState = defaultFlexiblePropertiesFilters,
): FlexiblePropertiesFilterState => ({
  ...defaults,
  searchText: (query[QueryConstants.SEARCH_TEXT] as string) || defaults.searchText,
  includeArchived: query[QueryConstants.ARCHIVED] === 'true' || defaults.includeArchived,
});

export const initializeViewModeFromRouter = (
  query: NextRouter['query'],
  defaultViewMode: FlexiblePropertiesViewMode = DEFAULT_FLEXIBLE_PROPERTIES_VIEW_MODE,
): FlexiblePropertiesViewMode =>
  isValidViewMode(query[QueryConstants.VIEW_MODE] as string)
    ? (query[QueryConstants.VIEW_MODE] as FlexiblePropertiesViewMode)
    : defaultViewMode;

export const initializeFlexiblePropertiesPageStateFromQuery = (query: NextRouter['query']) => ({
  filters: initializeFlexiblePropertiesFiltersFromRouter(query),
  viewMode: initializeViewModeFromRouter(query),
});

export const updateFlexibleRouterWithFilters = (
  router: NextRouter,
  filters: FlexiblePropertiesFilterState,
  viewMode: FlexiblePropertiesViewMode,
) =>
  replaceRouterQueryParams(router, ROUTES.PROPERTIES, {
    [QueryConstants.SEARCH_TEXT]: filters.searchText.trim() || undefined,
    [QueryConstants.ARCHIVED]: filters.includeArchived ? 'true' : undefined,
    [QueryConstants.VIEW_MODE]: viewMode !== DEFAULT_FLEXIBLE_PROPERTIES_VIEW_MODE ? viewMode : undefined,
  });
